// Author liang gang qiang
// Date 2023-09-08 10:52:46

class SithMomMaterialDrawingInfo {
constructor({
        id = null,
        material = '',
        type = '',
        number = '',
        version = '',
        part = '',
        designer = '',
        originFileName = '',
        application = '',
        description = '',
        uri = '',
        attachmentId = '',
        isHide = '',
        isDelete = '',
        remark = ''}
= {}) {
    this.id = id;
    this.material = material;
    this.type = type;
    this.number = number;
    this.version = version;
    this.part = part;
    this.designer = designer;
    this.originFileName = originFileName;
    this.application = application;
    this.description = description;
    this.uri = uri;
    this.attachmentId = attachmentId;
    this.isHide = isHide;
    this.isDelete = isDelete;
    this.remark = remark;
}
}

function newEntity() {
return new SithMomMaterialDrawingInfo();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'material',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.material',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'type',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.type',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'number',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.number',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'version',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.version',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'part',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.part',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'designer',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.designer',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'originFileName',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.originFileName',
        sortable: true,
        form: {
        type: 'input',
            linkTo: 'common_link',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'application',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.application',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'description',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'createdByName',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.createdByName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'drawingUploadTime',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.drawingUploadTime',
        sortable: true,
        form: {
            type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'downloadTimes',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.grid.downloadTimes',
        sortable: true,
        form: {
        type: 'input',
            linkTo: 'common_link',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    materialFilter : '',
    materialEqFilter : '',
    typeFilter : '',
    numberFilter : '',
    versionFilter : '',
    partFilter : '',
    designerFilter : '',
    originFileNameFilter : '',
    applicationFilter : '',
    descriptionFilter : '',
    uriFilter : '',
    attachmentIdFilter : '',
    isHideFilter : '',
    isDeleteFilter : '',
    createdByNameFilter : '',
    drawingUploadTimeRteFilter : '',
    drawingUploadTimeLteFilter : '',
    downloadTimesFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'materialFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.material',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.type',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'numberFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.number',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'versionFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.version',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'partFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.part',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'designerFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.designer',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'originFileNameFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.originFileName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applicationFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.application',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.description',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdByNameFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.createdByName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'drawingUploadTimeRteFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.drawingUploadTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'drawingUploadTimeLteFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.drawingUploadTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'downloadTimesFilter',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.filter.downloadTimes',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'material',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.material',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'type',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'number',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.number',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'version',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.version',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'part',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.part',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'designer',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.designer',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'originFileName',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.originFileName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'application',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.application',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'description',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.description',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'uri',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.uri',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentId',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.attachmentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isHide',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.isHide',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isDelete',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.isDelete',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.pds.sithMomMaterialDrawingInfo.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMomMaterialDrawingInfo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
